<template>
  <cascading-scale-unit-select
    v-model="scope.row.model"
    @change="scope.row.save()"
  ></cascading-scale-unit-select>
</template>

<script>

import CascadingScaleUnitSelect from "@/modules/cascading/components/scale/CascadingScaleUnitSelect.vue";

export default {
  name: 'cascading-element-scale-unit-table-column',
  components: { CascadingScaleUnitSelect },
  mixins: [],

  props: {
    scope: {type: Object, required: true},
  },
  data() {
    return {}
  },
  methods: {}
}

</script>

<style lang="scss">
@import "@/assets/css/project-variables";

</style>
